import { Box, Flex, Text } from '@chakra-ui/react';
import Button from '~/components/Button';
import Modal from '~/components/Modal/Modal';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const ConfirmDiscardChangesOnLeaveModal: React.FC<Props> = ({
  isOpen,
  onClose,
  onConfirm,
}) => (
  <Modal isOpen={isOpen} onClose={onClose}>
    <Modal.Header>Discard changes</Modal.Header>
    <Modal.Body>
      <Text>Are you sure you want to discard your changes? </Text>
    </Modal.Body>
    <Modal.Footer showDivider={false}>
      <Box flex={1} marginX={-4}>
        <Flex justifyContent="space-between">
          <Button onClick={onClose} variant="link">
            Cancel
          </Button>
          <Button onClick={onConfirm} colorScheme="red">
            Discard
          </Button>
        </Flex>
      </Box>
    </Modal.Footer>
  </Modal>
);
